import * as _ from "lodash";
import http from "../constant/api";

export const profileBusinessService = {
  listProfileBusinessHourByProfileId: async (profileId) => {
    const result = await http.get(
      `/api/profile-business/list/profile-id/${profileId}/type/BUSINESS_HOURS`
    );

    return result;
  },
  listProfileSpecialDayByProfileId: async (profileId) => {
    const result = await http.get(
      `/api/profile-business/list/profile-id/${profileId}/type/SPECIAL_DAY`
    );

    return result;
  },
  addProfileBusiness: async (data) => {
    const result = await http.post(`/api/profile-business/add`, data);

    return result;
  },
  editProfileBusiness: async (id, data) => {
    const result = await http.put(`/api/profile-business/${id}/edit`, data);

    return result;
  },
  removeProfileBusiness: async (id) => {
    const result = await http.delete(`/api/profile-business/${id}/remove`);

    return result;
  },
};
